import React, { useCallback } from 'react';
import { BaseAction } from '../../models';
import { ButtonAction } from '../button-action';
import { useNavigate } from 'react-router';
import { APP_ROUTES } from 'configs/routes';

interface Props extends BaseAction {}
export const ActionNextClinicalAppointment: React.FC<React.PropsWithChildren<Props>> = ({
  onDone: _onDone,
  actionKey,
  isLoading,
}) => {
  const navigate = useNavigate();
  const onDone = useCallback(() => {
    _onDone();
    navigate(APP_ROUTES.CLINICAL_MEETINGS().config);
  }, [_onDone, navigate]);
  return <ButtonAction actionKey={actionKey} onClick={onDone} disabled={isLoading} />;
};
